var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4004,
    cy: 21,
    r: 21,
    fill: "#E0F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2004 21L13.4004 12L32.8004 21L13.4004 30L16.2004 21ZM16.2004 21H32.0003",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/sent-icon.5fe2b0f9dd3eabdaa0e4e872672d74cf.svg";
export { ForwardRef as ReactComponent };